<template>
  <ContentPageLayout
    :page="pageKey"
    :title="content.h1"
    :subtitle="content.subtitle"
    :badge="content.badge"
    :show-hero="content.showHero !== false"
    :show-download="content.showDownload !== false"
  >
    <nav v-if="content.toc && content.toc.length" class="toc-nav">
      <a v-for="item in content.toc" :key="item.id" :href="'#' + item.id">{{ item.label }}</a>
    </nav>

    <section
      v-for="(section, idx) in content.sections"
      :key="idx"
      :id="section.id"
      class="content-section"
    >
      <h2 v-if="section.h2">{{ section.h2 }}</h2>
      <h3 v-if="section.h3">{{ section.h3 }}</h3>

      <p v-for="(p, pi) in section.paragraphs" :key="'p' + pi" v-html="p" />

      <ul v-if="section.list" class="bullet-list">
        <li v-for="(item, li) in section.list" :key="li" v-html="item" />
      </ul>

      <StepByStep v-if="section.steps" :steps="section.steps" />

      <table v-if="section.infoTable" class="info-table">
        <tbody>
          <tr v-for="(row, ri) in section.infoTable" :key="ri">
            <th>{{ row.label }}</th>
            <td v-html="row.value" />
          </tr>
        </tbody>
      </table>

      <div v-if="section.versionDownloads" class="version-download-list">
        <div
          v-for="item in section.versionDownloads"
          :key="item.version"
          class="version-download-row"
          :class="{ latest: item.isLatest }"
        >
          <div class="version-download-info">
            <strong>{{ item.version }}</strong>
            <span class="version-size">{{ item.size }}</span>
            <p>{{ item.note }}</p>
          </div>
          <button type="button" class="version-download-btn" @click="downloadVersion(item)">
            Download {{ item.version }}
          </button>
        </div>
      </div>

      <table v-if="section.compareTable" class="compare-table">
        <thead v-if="section.compareTable.headers">
          <tr>
            <th v-for="(h, hi) in section.compareTable.headers" :key="hi">{{ h }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, ri) in section.compareTable.rows" :key="ri">
            <td v-for="(cell, ci) in row" :key="ci" v-html="cell" :class="cellClass(cell)" />
          </tr>
        </tbody>
      </table>

      <div v-if="section.features" class="feature-grid">
        <div v-for="(feat, fi) in section.features" :key="fi" class="feature-card">
          <h3>{{ feat.title }}</h3>
          <p>{{ feat.text }}</p>
        </div>
      </div>

      <div v-if="section.prosCons" class="pros-cons">
        <div class="pros-box">
          <h3>Pros</h3>
          <ul>
            <li v-for="(item, pi) in section.prosCons.pros" :key="pi" v-html="item" />
          </ul>
        </div>
        <div class="cons-box">
          <h3>Cons</h3>
          <ul>
            <li v-for="(item, ci) in section.prosCons.cons" :key="ci" v-html="item" />
          </ul>
        </div>
      </div>

      <FAQ v-if="section.faqs" :faqs="section.faqs" />
    </section>
  </ContentPageLayout>
</template>

<script>
import ContentPageLayout from '@/components/ContentPageLayout.vue';
import FAQ from '@/components/FAQ.vue';
import StepByStep from '@/components/StepByStep.vue';
export default {
  name: 'PageRenderer',
  components: { ContentPageLayout, FAQ, StepByStep },
  inject: {
    apkActions: { default: null },
  },
  props: {
    content: { type: Object, required: true },
    pageKey: { type: String, default: 'gb' },
  },
  methods: {
    cellClass(cell) {
      if (cell === 'Yes' || cell === '✓') return 'yes';
      if (cell === 'No' || cell === '✗' || cell === 'Limited') return 'no';
      return '';
    },
    downloadVersion(item) {
      if (this.apkActions && this.apkActions.downloadVersion) {
        this.apkActions.downloadVersion(item);
      }
    },
  },
};
</script>
